export default "__VITE_ASSET__07aef589__"